define('model/contact.model',['require','exports','module','fukit/fukit'],function(require, exports, module) {
  var BaseModel = require('fukit/fukit').BaseModel;

  var ContactModel = BaseModel.extend({
    radioRequests: {
      'models ContactModel': '@constructor',
    },

    urlRoot: '/api/v2/contact',

    defaults: {
      countryGuid: null,
      countrySubdivisionGuid: null,
    },
  });
  module.exports = ContactModel;
});

